export const API_URL = "https://multi-user-api.2ndstage.app/"
//export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#53af3f', '#53af3f'],
        home_question: ['#53af3f', '#53af3f'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '18px 0rem 18px 0rem',
        photo: '0rem',
        textField: '18px 0rem 18px 0rem !important',
    },
    shadows : {
        default: 'none',
        home_question: 'none'
    },

    agendaStyle : {
        headerColor: '#53af3f',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '0px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: '#000',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#53af3f',
        headerBkgColor: '#1c0b28',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#000'
    },

    primary: '#53af3f',
    secondary: '#263238',
    accent: '#53af3f',
    text: '#eceff1',
    buttonText: {
        home_question: '#fff',
        default: '#fff'
    },
    background:"#000",

    homeQuestionIcon: true,

    poll:{
        default:"#000",
        answered:"#333333",
        correct: '#53af3f',
        wrong: '#170000'
    },
    pollBorder: {
        default:"#53af3f",
        answered:"#97BF0E",
        correct: '#53af3f',
        wrong: '#4f0001'
    },
    pollTextColor: {
        default:"#fff",
        answered:"#fff",
        correct: '#fff',
        wrong: '#4c2323'
    }
}